<template>
  <div
    class="card__item h-fit"
    :class="{
      'card__item--active': isSelected,
    }"
  >
    <bv-avatar
      :image="contact.avatar"
      :name="contact.full_name"
    />
    <div class="card__content">
      <div class="card__group">
        <h4 class="card__title">{{ contact.full_name }}</h4>
        <bv-btn
          class="h-fit p-1"
          :loading="changingFavoriteStatus"
          variant="text"
          @click.stop="contact.favorited ? handleRemoveFavorite() : handleAddFavorite()"
        >
          <template v-if="!changingFavoriteStatus">
            <img
              v-if="contact.favorited"
              src="@/assets/images/icons/star.svg"
            />
            <vsx-icon
              v-else
              color="#FF9500"
              icon-name="Star1"
              :size="16"
              type="linear"
            />
          </template>
        </bv-btn>
      </div>
      <div class="card__info">
        <span class="card__number">{{ contact.phone_number }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ContactCard',
    props: {
      contact: {
        type: Object,
        required: true,
      },
      changingFavoriteStatus: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      isSelected() {
        return this.$route.params.number === this.contact.phone_number || this.$route.query.id === this.contact.id;
      },
    },
    methods: {
      handleAddFavorite() {
        this.$emit('add-favorite', this.contact.id);
      },
      handleRemoveFavorite() {
        this.$emit('remove-favorite', this.contact.id);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card {
    &__item {
      display: flex;
      gap: 8px;
      align-items: center;
      padding: 8px;
      border-radius: 8px;
      border: 1px solid var(--gray100);
      background-color: var(--shadesWhite);
      cursor: pointer;

      &--active {
        border-color: var(--color-base-500, #095ea6);
        background-color: var(--color-base-50, #eff7fe);
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
      }
    }

    &__content {
      flex-grow: 1;
    }
    &__group {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-block-end: 8px;
    }
    &__title {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      color: var(--gray900);
    }

    &__info {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    &__number {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: var(--gray500);
    }
  }
</style>
